import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TarjetaPortada } from 'src/app/utils/models/usuario';
import { PromotionsComponent } from './promotions.component';

@Injectable()
export class PromotionsService {
  puedeVerInfo:boolean = true;
  constructor(private readonly dialog: MatDialog) {}
  open(tarjeta: TarjetaPortada): MatDialogRef<PromotionsComponent> {
    return this.dialog.open<PromotionsComponent, TarjetaPortada>(
      PromotionsComponent,
      {
        data: tarjeta,
        disableClose: true,
      }
    );
  }
}
